import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { createNotice } from "../../../_redux/notices/NoticesActions";
import { Modal } from "react-bootstrap";
import { NoticeCreateForm } from "./NoticeCreateForm";
import { toast } from "react-hot-toast";

export function NoticeCreateModal({ show, onHide }) {
  const btnRef = useRef();

  const dispatch = useDispatch();

  const onCreateClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const onCreateNotice = (notice) => {
    dispatch(
      createNotice({
        ...notice,
        type: parseInt(notice.type),
        branchId: notice.branchId === "" ? null : notice.branchId,
      })
    )
      .then(() => {
        onHide();
        toast.success("اطلاعیه با موفقیت ایجاد شد");
      })
      .catch(() => {
        toast.error("خطا هنگام ایجاد اطلاعیه");
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>ایجاد اطلاعیه جدید</Modal.Title>
      </Modal.Header>
      <Modal.Body></Modal.Body>
      <NoticeCreateForm btnRef={btnRef} createNotice={onCreateNotice} />
      <Modal.Footer>
        <div>
          <button
            type={"button"}
            onClick={onHide}
            className={"btn btn-light btn-elevate"}
          >
            لغو
          </button>
          <> </>
          <button
            type={"button"}
            onClick={onCreateClick}
            className={"btn btn-primary btn-elevate"}
          >
            ایجاد اطلاعیه
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
